import React from "react";
import "./App.css";
import Page from "./Page";
import Header from "./components/Header";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <Page />
      <Footer />
    </div>
  );
}

export default App;
